import DataPackage from "./DataPackage"
import MergedPosition from "./MergedPosition"
import Transaction from "./Transaction"

class DataPackageAdapter {
    static adaptDefault({ userId, owner, portfoliosTotalValue, currency, mergedPortfolios, transactions, portfoliosChangeInfo, portfoliosTotalAmount }) {
        const mergedPositions = mergedPortfolios.mergedMarketStocks.map(mp => {
            return new MergedPosition({
                stockId: mp.stockSignificantId,
                symbol: mp.stockSignificantSymbol,
                companyName: mp.companyName,
                percentageOfAllInvestment: mp.percentageOfAllInvestment,
                value: mp.amount.value,
                amountInvested: mp.amountInvested,
                userPositionDetails: mp.userPositionDetails,
                signifiantStockDayEvolution: mp.signifiantStockDayEvolution
            })
        })
        const adaptedTransactions = transactions ? transactions.map(t => new Transaction({ ...t })) : null
        const portfolios = {
            value: portfoliosTotalValue,
            currency
        }
        return new DataPackage({
            userId,
            owner,
            portfolios,
            transactions: adaptedTransactions,
            mergedPositions,
            portfoliosTotalAmount,
            portfoliosChangeInfo
        })
    }

    static adapt({ userId, owner, portfoliosTotalAmount, mergedPortfolios, portfoliosChangeInfo, packageMetadata }) {
        const mergedPositions = mergedPortfolios.mergedMarketStocks.map(mp => {
            return new MergedPosition({
                stockId: mp.stockSignificantId,
                symbol: mp.stockSignificantSymbol,
                companyName: mp.companyName,
                percentageOfAllInvestment: mp.percentageOfAllInvestment,
                value: mp.amount.value,
                amountInvested: mp.amountInvested,
                userPositionDetails: mp.userPositionDetails,
                signifiantStockDayEvolution: mp.signifiantStockDayEvolution
            })
        })
        const transactions = mergedPortfolios.transactions ? mergedPortfolios.transactions.map(t => new Transaction({ ...t })) : null
        //portfoliosTotalAmount.change = 8888.88 // Temporary fix to have change data in FriendZone view
        return new DataPackage({
            userId,
            owner,
            portfolios: portfoliosTotalAmount,
            transactions,
            mergedPositions,
            portfoliosTotalAmount,
            portfoliosChangeInfo,
            packageMetadata
        })
    }
}

export default DataPackageAdapter